"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _antd = require("antd");
var _Icon = _interopRequireDefault(require("../Icon"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _domain = require("../../utils/domain");
var _StretchMenuLayout = require("./StretchMenuLayout.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * 多了一層menu可選的layout
 */

const {
  SubMenu,
  Item
} = _antd.Menu;
const StretchMenuLayout = _ref => {
  let {
    header,
    sidebar,
    children,
    title,
    env,
    version = "localhost"
  } = _ref;
  const [isShow, setState] = (0, _react.useState)(false);
  const toggleSidebar = () => {
    setState(!isShow);
  };
  const urlGroup = (0, _react.useMemo)(() => {
    // 跨系統連結要留在使用者當下所在的網域：
    // nani 網域的 quesion bank 走到 nani 網域的 resource library
    // oneclasse 網域的 quesion bank 走到 oneclass 網域的 resource library
    const baseDomain = (0, _domain.getBaseDomain)() || _domain.ONECLASS_DOMAIN;
    const envSuffix = env !== "release" ? "-".concat(env) : "";
    const resourceLibrary = "https://resource-library".concat(envSuffix, ".").concat(baseDomain, "/");
    const tiku = "https://question-bank".concat(envSuffix, ".").concat(baseDomain, "/");
    return {
      resourceLibrary,
      tiku
    };
  }, [env]);
  return /*#__PURE__*/_react.default.createElement(_StretchMenuLayout.UiStretchMenuLayout, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "header"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons",
    onClick: () => toggleSidebar()
  }, isShow ? "close" : "menu"), header), /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("mark", isShow && "active")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("stretchMenu", isShow && "active")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "linkContainer"
  }, /*#__PURE__*/_react.default.createElement(_antd.Menu, {
    defaultSelectedKeys: ["1"],
    mode: "inline"
  }, /*#__PURE__*/_react.default.createElement(Item, {
    key: "publicCode",
    icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "grid_on"
    })
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(urlGroup.resourceLibrary, "publicCode?type=year")
  }, "\u5171\u7528\u4EE3\u78BC")), /*#__PURE__*/_react.default.createElement(Item, {
    key: "subject",
    icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "domain_verification"
    })
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(urlGroup.resourceLibrary, "subject")
  }, "\u79D1\u76EE\u8CC7\u6599")), /*#__PURE__*/_react.default.createElement(SubMenu, {
    key: "chapter",
    title: "\u7AE0\u7BC0\u8CC7\u6599",
    icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "list_alt"
    })
  }, /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
    key: "chapter"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(urlGroup.resourceLibrary, "chapter")
  }, "\u8AB2\u672C\u7AE0\u7BC0")), /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
    key: "all",
    disabled: true
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(urlGroup.resourceLibrary, "publicCode?type=year")
  }, "\u7E3D\u8907\u7FD2\u7AE0\u7BC0"))), /*#__PURE__*/_react.default.createElement(Item, {
    key: "product",
    icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "pageview",
      type: "outLined"
    }),
    disabled: true
  }, "\u7522\u54C1\u67E5\u8A62"), /*#__PURE__*/_react.default.createElement(Item, {
    key: "tiku",
    icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "eco",
      type: "outLined"
    })
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: urlGroup.tiku
  }, "\u984C\u5EAB")), /*#__PURE__*/_react.default.createElement(Item, {
    key: "onetube",
    icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "video_library",
      type: "outLined"
    }),
    disabled: true
  }, "\u5F71\u97F3\u5EAB"), /*#__PURE__*/_react.default.createElement(Item, {
    key: "book",
    icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "chrome_reader_mode",
      type: "outLined"
    }),
    disabled: true
  }, "\u96FB\u5B50\u66F8"))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "sidebar"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, title), sidebar, /*#__PURE__*/_react.default.createElement("div", {
    className: "version"
  }, version)), /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "scroll"
  }, children))));
};
var _default = exports.default = StretchMenuLayout;
StretchMenuLayout.propTypes = {
  title: _propTypes.default.node,
  header: _propTypes.default.element,
  sidebar: _propTypes.default.element,
  children: _propTypes.default.node,
  env: _propTypes.default.string,
  version: _propTypes.default.string
};